import { menuSelect } from 'instantsearch.js/es/widgets';
import { getInstance, registerWidget } from './searchsync-create-instance';
import { addFilter } from '@wordpress/hooks';

function initMenuSelectWidget() {
  const tgblAlgoliaDataJSON = window.atob(tgblSearchsyncDataEncoded);
  const tgblAlgoliaData = jQuery.parseJSON(tgblAlgoliaDataJSON);
  
  // Get all elements with menu select class
  const elements = document.querySelectorAll("[data-filter-type='menuSelect']")
  const elementsArray = Array.from(elements)
  
  // Group together menu select elements that share an index
  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute("data-index");
    if (!acc[dataIndexValue]) {
      acc[dataIndexValue] = [];
    }
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  // Loop through each index
  for (const dataIndexValue in elementsGroupedByIndex) {
    if (elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) {
      const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
      let search = getInstance(dataIndexValue);

      // Perform actions on elements with the same data-index value
      elementsWithSameIndex.forEach(element => {
        const widgetID = element.getAttribute('data-id')
        const widgetData = tgblAlgoliaData[widgetID]
        const attribute = widgetData.attribute

        if ( widgetData.preselected_menu_refinement ) {
          const ns = `tangible/menuselect/${ dataIndexValue }/${ widgetID }`;
          addFilter(
            'tangible-algolia-preselect-refinement',
            ns,
            (plan) => {
              plan.push({
                indexName: dataIndexValue,
                attribute,
                value: widgetData.preselected_menu_refinement,
                widgetType: 'menu_select',
              });
              return plan;
            }
          );
        }

        let SearchsyncMenuSelect = ($, search, element) => {
          search.addWidgets([
            menuSelect({
              container: element,
              attribute: attribute, 
              cssClasses: {
                root: 'tgbl-menu-select',
                noRefinementRoot: 'tgbl-menu-select__noRefinementRoot',
                select: 'tgbl-menu-select__select',
                option: 'tgbl-menu-select__option'
              },
            })
          ]);
          registerWidget(element);
        };
        SearchsyncMenuSelect($, search, element);
      });
    }
  }
}

export { initMenuSelectWidget }
